import { render, staticRenderFns } from "./SubtagForm.vue?vue&type=template&id=16d13071&scoped=true&"
import script from "./SubtagForm.vue?vue&type=script&lang=js&"
export * from "./SubtagForm.vue?vue&type=script&lang=js&"
import style0 from "./SubtagForm.vue?vue&type=style&index=0&id=16d13071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d13071",
  null
  
)

export default component.exports